<template>
    <div id="home">

        <div v-if="loading" class="loading"></div>

        <div class="category-slider-show">
            
            <div class="category-banner" v-if="bannerList.length > 0">
                <div v-for="(banner, index) in bannerList" :key="index">
                    <img :src="banner.image_base_path + banner.path" />
                </div>
            </div>

            <!-- <div data-v-3200222f="" class="category-banner slick-initialized slick-slider">
                <div aria-live="polite" class="slick-list draggable">
                    <div class="slick-track" role="listbox" style="opacity: 1; width: 1799px; transform: translate3d(0px, 0px, 0px);">
                        <div data-v-3200222f="" class="slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide10" style="width: 1799px;">
                            <img data-v-3200222f="" src="https://www.renkaatalle.fi:8080/storage/banners/renkaatalle-frontpage-car-1800x800-322-624cef51eb73b.jpg">
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="banner-area" :class="'home-page-'+currentLang">
                <div class="container"> 
                    <div class="row">
                        <div class="col-6 col-lg-10 col-md-8 col-sm-8">
                            <div class="row pl-3 pl-sm-0 pr-3 pr-sm-0 ">
                                <div>
                                    <div class="ql-editor" v-html="homePageBannerText.content" v-if="homePageBannerText"></div>
                                    <vue-editor style="display:none" />
                                </div>
                                <!-- <h1 class="d-block w-100"><span>{{ $t('Welcome to renkaatalle.fi web shop') }}</span>
                                    {{ $t('Tyres cheaply and easily, more than 1000 free fitting times daily') }}</h1> -->
                                <!-- <form class="form-inline pt-4 flex-column align-items-start" @submit.prevent="onSubmitLicencePlateSearch('searchForm')">
                                    <div class="trucktyre-block mb-4">
                                        <h2 class="color-white font-20 mb-3 text-shadow">{{ $t('Tyres you are looking for') }}?</h2>
                                        <select 
                                            id="searchselect" 
                                            name="cars" 
                                            class="custom-select vehicle-selection">
                                                <option name="cars" selected>Cars</option>
                                                <option name="trucks" value="volvo">Trucks</option>
                                        </select>

                                        <b-form-select 
                                            v-model="licencePlateSearch.vehicleType" 
                                            
                                            id="carType" 
                                            name="carType" 
                                            @change="changeVehicleType($event)"
                                            class="custom-select vehicle-selection"
                                            value-field="car_type"
                                            text-field="car_type">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>{{ $t('Vehicle Type') }}</b-form-select-option>
                                                </template>
                                                <b-form-select-option v-for="vehicleType in vehicleTypes" :value="vehicleType.car_type" :key="vehicleType.car_type">
                                                    <span v-if="vehicleType.car_type == 'Car'">{{ $t('Car/SUV/4X4') }}</span>
                                                    <span v-else-if="vehicleType.car_type == 'Light Truck'">{{ $t('Light Commercial Vehicle') }}</span>
                                                </b-form-select-option>
                                                
                                            </b-form-select>
                                    </div>
                                    <div class="cartyre-block">
                                        <div class="form-group mr-sm-3 mb-2">
                                            <b-form-input
                                                type="text"
                                                class="form-control licence-plate"
                                                placeholder="Licence Plate"
                                                v-model.trim="licencePlateSearch.licencePlate">
                                            </b-form-input>
                                        </div>
                                        <button type="button"  @click="searchByLicencePlate()" :disabled="licencePlateSearch.licencePlate == '' " class="btn licence-button bg-yellow mb-2">Search</button>
                                    </div>
                                </form> -->
                            </div>
                        </div>
                        <!-- Removed the condition to display again The man image-->
                        <div class="col-6 col-lg-2 col-md-4 col-sm-4" v-if="!1">
                            <img v-if="currentLang == 'en_GB'" v-b-modal.modal-2 src="images/home-page-bubble-msg-icon-en.png" class="bubble-msg-icon">
                            <img v-if="currentLang == 'fi_FI'" v-b-modal.modal-2 src="images/home-page-bubble-msg-icon-fi.png" class="bubble-msg-icon">
                            <b-modal id="modal-2" hide-footer hide-header >
                                <b-button class="closeicon" @click="$bvModal.hide('modal-2')"><i class="fas fa-times"></i></b-button>
                                <video 
                                    class="embed-responsive-item" 
                                    width="100%" 
                                    controls 
                                    autoplay="true"
                                    id="video-play">
                                    <source v-if="currentLang == 'en_GB'" src="videos/Renkaatalle_presentation_1080p_EN_FINAL.mp4" id="video-container-en" type="video/mp4">
                                    <source v-if="currentLang == 'fi_FI'" src="videos/Renkaatalle_esittelyvideo_1080p_FI_FINAL.mp4" id="video-container-fi" type="video/mp4">
                                </video>
                            </b-modal>
                        </div>
                    </div>
                </div>

                <div class="search-tyre">  
                    <div class="container">
                            <b-card no-body class="bg-transparent border-0">
                                <b-tabs card class="bg-transparent px-lg-5 px-md-3 px-sm-2" :content-class='{"search-tyre-by-dealer" : ("Service Points" == selectedSearchedTab)}'>
                                    <b-tab  class="bg-transparent" @click="changeVehicleType('Car')" :active="'Car' == activeVehicleTypes">
                                      <template #title>
                                        <div class="tab-icon car-icon"></div>
                                        <p class="m-0 font-weight-bold text-center">
                                          {{ $t('Car') }}
                                        </p>
                                      </template>
                                        <b-card-text>
                                            <div class="cs-search-home">
                                                
                                                <div class="srch-form">
                                                    <form class="form-inline">
                                                        <div class="srch-title">
                                                            <p>{{ $t('Search by tyre size') }} :</p>
                                                        </div>
                                                        <div class="">
                                                            <b-modal id="modal-1"    hide-footer hide-header >
                                                                    <b-button class="closeicon" @click="$bvModal.hide('modal-1')"><i class="fas fa-times"></i></b-button>
                                                                <img v-show="currentLang == 'en_GB'" src="../../public/images/Renkaatalle-rengasvalinta_english.png" />
                                                                <img v-show="currentLang == 'fi_FI'" src="../../public/images/Renkaatalle-rengasvalinta_finnish.png" />
                                                            </b-modal>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Width') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.width"
                                                                id="widths" 
                                                                name="widths"
                                                                @change="changeWidth($event)"
                                                                class="custom-select"
                                                                :options="widths"
                                                                value-field="width"
                                                                text-field="width">
                                                                <!-- <option selected>{{ $t('Width') }}</option> -->
                                                                    <!-- <template v-slot:first>
                                                                        <b-form-select-option :value="null" disabled>255</b-form-select-option>
                                                                    </template> -->
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Height') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.height"
                                                                id="height" 
                                                                name="height" 
                                                                @change="changeHeight($event)"
                                                                class="custom-select"
                                                                :options="heights"
                                                                value-field="aspect_ratio" 
                                                                text-field="aspect_ratio">
                                                                    <!-- <template v-slot:first>
                                                                        <b-form-select-option :value="null" disabled>55</b-form-select-option>
                                                                    </template> -->
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Wheel Diameter') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.diameter"
                                                                id="diameter" 
                                                                name="diameter" 
                                                                @change="changeDiameter($event)"
                                                                class="custom-select"
                                                                :options="diameters"
                                                                value-field="diameter"
                                                                text-field="diameter">
                                                                    <!-- <template v-slot:first>
                                                                        <b-form-select-option :value="null" disabled>16</b-form-select-option>
                                                                    </template> -->
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Season') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.tyreSeason"
                                                                id="tyreSeason" 
                                                                name="tyreSeason" 
                                                                @change="changeTyreSeason($event)"
                                                                class="custom-select"
                                                                value-field="name" 
                                                                text-field="name">
                                                                    <!-- <template v-slot:first>
                                                                        <b-form-select-option :value="null">{{ $t('All Seasons') }}</b-form-select-option>
                                                                    </template> -->

                                                                    <b-form-select-option  
                                                                        v-for="allTyreSeason in tyreSeasonsFiltered" 
                                                                        :value="allTyreSeason.name" 
                                                                        :key="allTyreSeason.name" 
                                                                        >{{ $t(allTyreSeason.name) }}</b-form-select-option>
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Brand') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.brand"
                                                                id="brand" 
                                                                name="brand" 
                                                                @change="changeBrand($event)"
                                                                class="custom-select"
                                                                value-field="name" 
                                                                text-field="name">
                                                                    <b-form-select-option value="All">All</b-form-select-option>
                                                                    <b-form-select-option  
                                                                        v-for="brand in brands" 
                                                                        :value="brand.name" 
                                                                        :key="brand.name" 
                                                                        >{{ $t(brand.name) }}</b-form-select-option>
                                                            </b-form-select>
                                                        </div>
                                                        <button type="button"  @click="searchByTyreSize()" class="btn search-button"> {{ $t('Search') }}<i class="search-icon"></i></button>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-start">
                                                <div class="d-block d-lg-flex justify-content-between align-items-start">
                                                    <b-button v-b-modal.modal-1 class="btn button-opaque" >{{ $t('SIZE MARKING') }} <i class="info-icon"></i></b-button>
                                                    <img class="sizeRefImg" src="images/img-tyre-size-referance.png" alt="">
                                                </div>
                                                <!-- <b-button v-b-modal.modal-1 class="btn button-opaque" >More Filters <i class="more-filer-icon"></i></b-button> -->
                                                <b-button @click="searchByTyreSize()" class="btn button-opaque" >{{ $t('More Filters') }} <i class="more-filer-icon"></i></b-button>
                                            </div>
                                            
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab  class="bg-transparent" @click="changeVehicleType('Light Truck')" :active="'Light Truck' == activeVehicleTypes">
                                      <template #title>
                                        <div class="tab-icon light-truck-icon"></div>
                                        <p class="m-0 font-weight-bold text-center">
                                        {{ $t('Van') }}
                                        </p>
                                      </template>
                                        <b-card-text>
                                            <div class="cs-search-home">
                                                
                                                <div class="srch-form">
                                                    <form class="form-inline">
                                                        <div class="srch-title">
                                                            <p>{{ $t('Search by tyre size') }}</p>
                                                        </div>
                                                        <div class="">
                                                            <b-modal id="modal-1"    hide-footer hide-header >
                                                                    <b-button class="closeicon" @click="$bvModal.hide('modal-1')"><i class="fas fa-times"></i></b-button>
                                                                <img v-show="currentLang == 'en_GB'" src="../../public/images/Renkaatalle-rengasvalinta_english.png" />
                                                                <img v-show="currentLang == 'fi_FI'" src="../../public/images/Renkaatalle-rengasvalinta_finnish.png" />
                                                            </b-modal>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Width') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.width"
                                                                value="255"
                                                                id="widths" 
                                                                name="widths"
                                                                @change="changeWidth($event)"
                                                                class="custom-select"
                                                                :options="widths"
                                                                value-field="width"
                                                                text-field="width">
                                                                    <template v-slot:first>
                                                                        <b-form-select-option :value="255" disabled></b-form-select-option>
                                                                    </template>
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Height') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.height"
                                                                id="height" 
                                                                name="height" 
                                                                @change="changeHeight($event)"
                                                                class="custom-select"
                                                                :options="heights"
                                                                value-field="aspect_ratio" 
                                                                text-field="aspect_ratio">
                                                                    <template v-slot:first>
                                                                        <b-form-select-option :value="null" disabled></b-form-select-option>
                                                                    </template>
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Wheel Diameter') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.diameter"
                                                                id="diameter" 
                                                                name="diameter" 
                                                                @change="changeDiameter($event)"
                                                                class="custom-select"
                                                                :options="diameters"
                                                                value-field="diameter"
                                                                text-field="diameter">
                                                                    <template v-slot:first>
                                                                        <b-form-select-option :value="null" disabled></b-form-select-option>
                                                                    </template>
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Season') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.tyreSeason"
                                                                id="tyreSeason" 
                                                                name="tyreSeason" 
                                                                @change="changeTyreSeason($event)"
                                                                class="custom-select"
                                                                value-field="name" 
                                                                text-field="name">
                                                                    <!-- <template v-slot:first>
                                                                        <b-form-select-option :value="null">{{ $t('All Seasons') }}</b-form-select-option>
                                                                    </template> -->

                                                                    <b-form-select-option  
                                                                        v-for="allTyreSeason in tyreSeasonsFiltered" 
                                                                        :value="allTyreSeason.name" 
                                                                        :key="allTyreSeason.name" 
                                                                        >{{ $t(allTyreSeason.name) }}</b-form-select-option>
                                                            </b-form-select>
                                                        </div>
                                                        <div class="form-items">
                                                            <label>{{ $t('Brand') }}</label>
                                                            <b-form-select 
                                                                v-model="searchBySize.brand"
                                                                id="brand" 
                                                                name="brand" 
                                                                @change="changeBrand($event)"
                                                                class="custom-select"
                                                                value-field="name" 
                                                                text-field="name">
                                                                    <b-form-select-option value="All">All</b-form-select-option>
                                                                    <b-form-select-option  
                                                                        v-for="brand in brands" 
                                                                        :value="brand.name" 
                                                                        :key="brand.name" 
                                                                        >{{ $t(brand.name) }}</b-form-select-option>
                                                            </b-form-select>
                                                        </div>
                                                        <button type="button"  @click="searchByTyreSize()" :disabled="(searchBySize.width == null || searchBySize.height == null || searchBySize.diameter == null)" class="btn search-button">{{ $t('Search') }}<i class="search-icon"></i></button>
                                                        
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-start">
                                                <div class="d-block d-lg-flex justify-content-between align-items-start">
                                                    <b-button v-b-modal.modal-1 class="btn button-opaque" >{{ $t('SIZE MARKING') }} <i class="info-icon"></i></b-button>
                                                    <img class="sizeRefImg" src="images/img-tyre-size-referance.png" alt="">
                                                </div>
                                                <!-- <b-button v-b-modal.modal-1 class="btn button-opaque" >More Filters <i class="more-filer-icon"></i></b-button> -->
                                                <b-button @click="searchByTyreSize()" class="btn button-opaque" >{{ $t('More Filters') }} <i class="more-filer-icon"></i></b-button>
                                            </div>
                                        </b-card-text>
                                    </b-tab>
                                    <b-tab  class="bg-transparent" @click="changeVehicleType('Truck')" :active="'Truck' == activeVehicleTypes">
                                      <template #title>
                                        <div class="tab-icon truck-icon"></div>
                                        <p class="m-0 font-weight-bold text-center">
                                          {{ $t('Truck') }}
                                        </p>
                                      </template>
                                      <b-card-text>
                                        <div class="cs-search-home">

                                          <div class="srch-form">
                                            <form class="form-inline">
                                              <div class="srch-title">
                                                <p>{{ $t('Search by tyre size') }} :</p>
                                              </div>
                                              <div class="">
                                                <b-modal id="modal-1"    hide-footer hide-header >
                                                  <b-button class="closeicon" @click="$bvModal.hide('modal-1')"><i class="fas fa-times"></i></b-button>
                                                  <img v-show="currentLang == 'en_GB'" src="../../public/images/Renkaatalle-rengasvalinta_english.png" />
                                                  <img v-show="currentLang == 'fi_FI'" src="../../public/images/Renkaatalle-rengasvalinta_finnish.png" />
                                                </b-modal>
                                              </div>
                                              <div class="form-items">
                                                <label>{{ $t('Width') }}</label>
                                                <b-form-select
                                                    v-model="searchBySize.width"
                                                    id="widths"
                                                    name="widths"
                                                    @change="changeWidth($event)"
                                                    class="custom-select"
                                                    :options="widths"
                                                    value-field="width"
                                                    text-field="width">
                                                  <!-- <option selected>{{ $t('Width') }}</option> -->
                                                  <!-- <template v-slot:first>
                                                      <b-form-select-option :value="null" disabled>255</b-form-select-option>
                                                  </template> -->
                                                </b-form-select>
                                              </div>
                                              <div class="form-items">
                                                <label>{{ $t('Height') }}</label>
                                                <b-form-select
                                                    v-model="searchBySize.height"
                                                    id="height"
                                                    name="height"
                                                    @change="changeHeight($event)"
                                                    class="custom-select"
                                                    :options="heights"
                                                    value-field="aspect_ratio"
                                                    text-field="aspect_ratio">
                                                  <!-- <template v-slot:first>
                                                      <b-form-select-option :value="null" disabled>55</b-form-select-option>
                                                  </template> -->
                                                </b-form-select>
                                              </div>
                                              <div class="form-items">
                                                <label>{{ $t('Wheel Diameter') }}</label>
                                                <b-form-select
                                                    v-model="searchBySize.diameter"
                                                    id="diameter"
                                                    name="diameter"
                                                    @change="changeDiameter($event)"
                                                    class="custom-select"
                                                    :options="diameters"
                                                    value-field="diameter"
                                                    text-field="diameter">
                                                  <!-- <template v-slot:first>
                                                      <b-form-select-option :value="null" disabled>16</b-form-select-option>
                                                  </template> -->
                                                </b-form-select>
                                              </div>
                                              <div class="form-items">
                                                <label>{{ $t('Season') }}</label>
                                                <b-form-select
                                                    v-model="searchBySize.tyreSeason"
                                                    id="tyreSeason"
                                                    name="tyreSeason"
                                                    @change="changeTyreSeason($event)"
                                                    class="custom-select"
                                                    value-field="name"
                                                    text-field="name">
                                                  <!-- <template v-slot:first>
                                                      <b-form-select-option :value="null">{{ $t('All Seasons') }}</b-form-select-option>
                                                  </template> -->

                                                  <b-form-select-option
                                                      v-for="allTyreSeason in tyreSeasonsFiltered"
                                                      :value="allTyreSeason.name"
                                                      :key="allTyreSeason.name"
                                                  >{{ $t(allTyreSeason.name) }}</b-form-select-option>
                                                </b-form-select>
                                              </div>
                                              <div class="form-items">
                                                <label>{{ $t('Brand') }}</label>
                                                <b-form-select
                                                    v-model="searchBySize.brand"
                                                    id="brand"
                                                    name="brand"
                                                    @change="changeBrand($event)"
                                                    class="custom-select"
                                                    value-field="name"
                                                    text-field="name">
                                                  <b-form-select-option value="All">All</b-form-select-option>
                                                  <b-form-select-option
                                                      v-for="brand in brands"
                                                      :value="brand.name"
                                                      :key="brand.name"
                                                  >{{ $t(brand.name) }}</b-form-select-option>
                                                </b-form-select>
                                              </div>
                                              <button type="button"  @click="searchByTyreSize()" class="btn search-button"> {{ $t('Search') }}<i class="search-icon"></i></button>
                                            </form>
                                          </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-start">
                                          <div class="d-block d-lg-flex justify-content-between align-items-start">
                                            <b-button v-b-modal.modal-1 class="btn button-opaque" >{{ $t('SIZE MARKING') }} <i class="info-icon"></i></b-button>
                                            <img class="sizeRefImg" src="images/img-tyre-size-referance.png" alt="">
                                          </div>
                                          <!-- <b-button v-b-modal.modal-1 class="btn button-opaque" >More Filters <i class="more-filer-icon"></i></b-button> -->
                                          <b-button @click="searchByTyreSize()" class="btn button-opaque" >{{ $t('More Filters') }} <i class="more-filer-icon"></i></b-button>
                                        </div>

                                      </b-card-text>
                                    </b-tab>
                                    <b-tab  :active="'Service Points' == activeVehicleTypes" @click=" selectedSearchedTab = 'Service Points' " :class="['pb-3']">
                                      <template #title>
                                        <div class="tab-icon service-point-icon"></div>
                                        <p class="m-0 font-weight-bold text-center">
                                        {{ $t('Service Points') }}
                                        </p>
                                      </template>
                                    <b-card-text>
                                      <div class="cs-search-home container search-by-service-point-container set-sticky pb-3">
                                        <div class="w-100 py-3 pb-lg-0">
                                          <!-- align-items-normal -->
                                          <form class="form-inline  sp-search-form" @submit.prevent="() => {return false;}">
                                            <div class="form-group srch-title sp-title sp-margin-right-lg-2 sp-mr-767" :class="{'sp-title-finish' : (currentLang === 'fi_FI')}">
                                              <p class=""> {{ $t('Find a service point') }} </p>
                                            </div>
                                            <div class="sp-group-item-767">
                                              <div class="form-group sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                                                <label for="sp_vehicle_type">{{ $t("Select vehicle type") }}</label>
                                                <b-form-select
                                                    id="sp_vehicle_type"
                                                    class=""
                                                    :options="currentLang === 'fi_FI' ? vehicle_types_fi : vehicle_types"
                                                    v-model="default_v_t"
                                                    @change="searchServicePoints()"
                                                ></b-form-select>
                                              </div>
                                              <div class="form-group d-max-767 sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                                                <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                                                <b-form-select
                                                    id="sp_maximum_distance"
                                                    class=""
                                                    :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                                                    v-model="defaultKilometer"
                                                    @change="searchServicePoints()"
                                                ></b-form-select>
                                              </div>
                                            </div>
                                            <div class="form-group sp-form-item sp-input-group flex-grow-1 mr-2 sp-margin-top-mdsm-2">
                                              <label>{{ $t("Type your city or post code") }}</label>
                                              <vue-google-autocomplete
                                                  id="map"
                                                  classname="form-control w-100 google-input-box sp-search-input-append"
                                                  :class="addressError"
                                                  :placeholder="$t('Type your city or post code')"
                                                  v-on:placechanged="getAddressData"
                                                  :country="['fi']"
                                                  v-model="address"
                                                  required="true"
                                                  types="geocode"
                                                  ref="autocomplete"
                                                  @keyup="clearSearchedServicePoint($event)"
                                              >
                                              </vue-google-autocomplete>
                                              <button type="button" @click="searchServicePoints()" class="btn search-button sp-search-btn-append">
                                                <i class="search-icon"></i>
                                              </button>
                                            </div>
                                            <div class="form-group sp-form-item mr-2 sp-margin-top-mdsm-2 d-none-767">
                                              <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                                              <b-form-select
                                                  id="sp_maximum_distance"
                                                  class=""
                                                  :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                                                  v-model="defaultKilometer"
                                                  @change="searchServicePoints()"
                                              ></b-form-select>
                                            </div>
                                            <div class="form-group sp-form-item sp-margin-right-lg-2 sp-margin-top-mdsm-2 d-max-425 sp-mr-425 d-min-992">
                                              <button type="button" class="btn search-button sp-w-100-425 sp-br-remove-425" @click="searchServicePoints()">
                                                <span class="search-button-title">
                                                  {{ $t('Show service points') }}
                                                </span>
                                                <i class="search-icon"></i>
                                              </button>
                                            </div>
                                          </form>
                                          <div class="hm-single-dealer-container d-flex align-items-start justify-content-between pb-lg-0 p-sm-0 border-bottom flex-wrap flex-sm-wrap" v-if="service_points.length > 0">
                                            <div class="service-point-column font-weight-bold sp-mt-425">
                                              <span class="float-right cursor-pointer" id="popover-target-sorting-content">
                                                <span class="font-12">
                                                  {{ getSortingTitle }}
                                                  <i v-if="defaultSort === 0" class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 1" class="fa fa-sort-numeric-desc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 2" class="fa fa-sort-alpha-asc" aria-hidden="true"></i>
                                                  <i v-if="defaultSort === 3" class="fa fa-sort-alpha-desc" aria-hidden="true"></i>
                                                </span>
                                              </span>
                                              <p class="font-16 mt-2 mb-0 font-weight-light">
                                                {{ ($t('service_point_title_tagline')).replace('{kilometer}', defaultKilometer).replace('{city}', address).replace('{service_point_count}', (service_points.length || 0)) }}
                                              </p>
                                              <b-popover target="popover-target-sorting-content" triggers="hover" placement="bottom">
                                                <b-form-select :options="currentLang === 'fi_FI' ? sortingOptions_fi :  sortingOptions" v-model="defaultSort" @change="sortSearchedServicePoints()"></b-form-select>
                                              </b-popover>
                                            </div>
                                            <div class="service-column font-weight-bold px-3 d-none-767">
                                              <p class="font-16 mt-2 font-weight-light">{{ $t('Installation price per tyre') }} </p>
                                            </div>
                                            <div class="next-available-time-column font-weight-bold px-3 d-min-992">
                                              <p class="font-16 mt-2 mb-0 font-weight-light" id="thisthis">{{ $t("Next available time") }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="loading" v-if="sbspLoader"></div>
                                      <div class="search-by-service-point-container" v-if="showServices && service_points.length && !sbspLoader">
                                        <div class="w-100" v-if="showServices && service_points.length && !sbspLoader">
                                          <div v-for="(service_point, service_point_index) in service_points" :key="service_point_index"
                                               class="hm-single-dealer-container border mb-3"
                                               :class="{'active' : (selectedServicePoint != null && service_point.id == selectedServicePoint.id), 'mt-lg-3 mt-md-3 mt-sm-2' : service_point_index === 0}"
                                          >
                                            <div class="d-flex align-items-start justify-content-between px-3 pt-3 pb-lg-3 flex-wrap flex-sm-wrap">
                                              <div class="service-point-column">
                                                <ul class="service-point-details font-14-991">
                                                  <li class="online-icon d-max-767" v-if="service_point.time_slots.length">{{ $t('Online appointment available') }} </li>
                                                  <li class="phone-icon d-max-767" v-else>
                                                    {{ $t('Appointment by phone') }} :
                                                    <p class="pl-1">{{ $t('tel')}}. {{service_point.contact_number}}</p>
                                                  </li>
                                                  <li class="organization-name">
                                                    {{ service_point.company_name }}
                                                    <span class="float-right cursor-pointer mr-2" :id="`service_point_info_${service_point.id}`"><i class="info-icon"></i></span>
                                                    <popover-service-point-right :service_point="service_point"></popover-service-point-right>
                                                  </li>
                                                  <li class="distance-icon d-flex align-items-center">
                                                    <span class="font-italic km-container">{{ parseFloat(service_point.distance_km).toFixed(2) }} {{ $t('km') }}</span>
                                                    <div class="sp-logo-container" v-if="service_point.profile_image_path !== null">
                                                      <img :src="`${service_point.image_base_path}${service_point.profile_image_path}`" class="sp-logo">
                                                    </div>
                                                  </li>
                                                  <li class="address-icon">{{ service_point.address_line_1 }} {{ service_point.address_line_2 !== 'null' ? service_point.address_line_2  : '' }}</li>
                                                  <li class="opening-hour-icons" v-if="Object.entries(service_point.time_slots).length" :id="`opening_hour_${service_point.id}`">
                                                    {{ $t('Opening hours') }}
                                                    <HomepageOpeningHourPopover :service_point="service_point"/>
                                                  </li>
                                                  <li class="address-last">
                                                    {{ !((service_point.address_line_1).toLowerCase().includes(service_point.zipcode.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.zipcode.toLowerCase())) ? (service_point.zipcode + ',') : ''}}
                                                    {{ !(service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase())) ? service_point.city : ''}}
                                                  </li>
                                                  <li class="time-icon d-max-991" v-if="service_point.time_slots.length">
                                                    {{ nextAvailableSlotDateCommon(service_point) }}
                                                    <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id" @click="showModal = true"><i class="info-icon" :id="'nat_responsive-'+service_point.dealer_id"></i></span>
                                                    <b-popover :target="'nat_responsive-'+service_point.dealer_id" triggers="hover" placement="top" :custom-class="'custom-popover-nat-info'">
                                                      {{ $t("Click here to show the available timeslots") }}
                                                    </b-popover>
                                                  </li>
                                                </ul>
                                                <div class="d-max-767 d-service-block-max-767">
                                                  <HomeViewAttachedService :service_point="service_point" id_prefix="d_max_767" :display_service_limit="2"></HomeViewAttachedService>
                                                </div>
                                              </div>
                                              <div class="service-column px-3 d-none-767">
                                                <HomeViewAttachedService :service_point="service_point" id_prefix="d_min_767" :display_service_limit="3"></HomeViewAttachedService>
                                                <ul class="service-point-details font-14-991" v-if="service_point.time_slots.length">
                                                  <li class="online-icon d-max-991">{{ $t('Online appointment available') }} </li>
                                                </ul>
                                              </div>
                                              <div class="next-available-time-column px-3 d-min-992">
                                                <ul class="service-point-details">
                                                  <li class="time-icon" v-if="service_point.time_slots.length">
                                                    {{ nextAvailableSlotDateCommon(service_point) }}
                                                    <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id" @click="showModal = true"><i class="info-icon" :id="'nat-'+service_point.dealer_id"></i></span>
                                                    <b-popover :target="'nat-'+service_point.dealer_id" triggers="hover" placement="top" :custom-class="'custom-popover-nat-info'">
                                                      {{ $t("Click here to show the available timeslots") }}
                                                    </b-popover>
                                                  </li>
                                                  <li class="online-icon" v-if="service_point.time_slots.length">{{ $t('Online appointment available') }} </li>
                                                  <li class="phone-icon" v-else>
                                                    {{ $t('Appointment by phone') }} :
                                                    <p class="pl-1">{{ $t('tel')}}. {{service_point.contact_number}}</p>
                                                  </li>
                                                </ul>
                                                <div class="pt-2" v-if="!1"><button class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 bg-dark color-white call-appointment-btn" ><i class="fa fa-phone"></i> {{ $t("Appointment") }}</button></div>
                                                <div class="pt-2"><button @click="selectAndRemoveServicePoint(service_point);searchByTyreSize('yes')" class="text-uppercase bg-success pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn" ><i class="fa fa-search"></i> {{ $t("Search Tyres") }}</button></div>
                                              </div>
                                            </div>

                                            <div class="d-max-991">
                                              <div class="d-flex align-content-center justify-content-end appointment-search-btn-container py-2">
                                                <div v-if="!1" class="w-50-appointment-btn">
                                                  <button class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 btn-block bg-dark color-white call-appointment-btn" ><i class="fa fa-phone"></i> {{ $t("Appointment") }}</button>
                                                </div>
                                                <div class="w-50-search-btn">
                                                  <button @click="selectAndRemoveServicePoint(service_point);searchByTyreSize('yes')" class="text-uppercase bg-success btn-sm-block pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn btn-block" ><i class="fa fa-search"></i> {{ $t("Search Tyres") }}</button>
                                                </div>
                                              </div>
                                            </div>
                                            <b-modal class="modal" :hide-footer="true" title-tag='h4' header-text-variant='dark' title-class="text-uppercase" name="modal" v-if="showModal" :id="'my-modal-'+service_point.dealer_id">
                                              <template #modal-header="{ close }">
                                                <div>
                                                  <h4 class="text-uppercase">{{ $t('Available time') }}</h4>
                                                  <p class="mb-0">{{ $t("available_time_tagline") }}</p>
                                                </div>
                                                <button type="button" aria-label="Close" class="close text-dark" @click="close()">×</button>
                                              </template>
                                              <div v-if="service_point">
                                                <appointment-popup @goToError="goToError" @hidepopup="removeAppointmentPopup" :allowedTimes="[]" :dealerService="service_point" :availableDays="availableSlotDayCommon(service_point)" :localDealersList="service_points" :showProceedButton="false"></appointment-popup>
                                              </div>
                                            </b-modal>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mt-3" v-if="showServices && service_points.length == 0 && !sbspLoader">
                                        <p class="text-danger">{{ $t("It seems there is no service point available for the selected location. Kindly contact us on Chat or customer service 0405529803 for further assistance.") }}</p>
                                      </div>

                                    </b-card-text>
                                  </b-tab>
                                </b-tabs>
                            </b-card>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-else class="loading"></div> -->

        <div class="five-reason">
            <div class="container">
                <h2 class="text-uppercase"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                <ul>
                    <li>
                        <i class="reason-icon reason-1"></i>
                        <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                    </li>
                    <li>
                        <i class="reason-icon reason-4"></i>
                        <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                    </li>
                    <li>
                        <i class="reason-icon reason-2"></i>
                        <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                    </li>
                    <li>
                        <i class="reason-icon reason-3"></i>
                        <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>                        
                    </li>
                    <li>
                        <i class="reason-icon reason-5"></i>
                        <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="top-product">
            <div class="container">        
                <div class="row offers-banner" v-if="offerList.length > 0">
                    <div v-for="offer in offerList" :key="offer.id">
                        <template v-if="currentLang == 'fi_FI'">
                            <a :href="offer.url"><img height="370px" width="250px" :src="offer.image_base_path + offer.image_fi" :alt="offer.label" /></a>
                        </template>
                        <template v-else>
                            <a :href="offer.url"><img height="370px" width="250px" :src="offer.image_base_path + offer.image_en" :alt="offer.label" /></a>
                        </template>                    
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="heading">
                        <!-- <h2 class="text-uppercase">{{ $t('GREAT SERVICE AND BEST PRODUCTS') }}</h2> -->
                        <!-- <p>{{ $t("We are importing cheap and high quality new passenger car, van and truck / bus tyres. The brands we import are Nexen, West Lake, Rotalla, Event and Insa-Turbo new tyres. We are also the official wholesaler of Dunlop tyres in Finland") }}.</p> -->
                        <!-- <p>{{ $t('We provide just the right tires for you and you can also book installation if needed and pay everything in advance. We have more than 200 service points and 1 000 installation times every day. Buying tires doesn’t get any easier!') }} </p>
                        <p class="highlight-text">{{ $t('Ordering tires with installation you will receive free delivery.') }} </p>
                        <p><b>{{ $t('Welcome shopping!') }}</b></p> -->
                        <div class="ql-editor" v-html="cmsPageContent.translations[0].content" v-if="cmsPageContent.translations"></div>
                        <vue-editor style="display:none" />
                    </div>
                </div>
            </div>
        </div>

        <div class="our-client">
            <div class="container">
                <h2 class="text-uppercase"> <span>{{ $t('We represent') }} </span> {{ $t('the following') }} <span>{{ $t('brands') }}</span></h2>
                <div class="customer-logos">
                    <div class="slide"><img src="images/brands/Pirelli.png"></div>
                    <div class="slide"><img src="images/brands/Falken.png"></div>
                    <div class="slide"><img src="images/brands/Nexen.png"></div>
                    <div class="slide"><img src="images/brands/Zeetex.jpg"></div>
                    <div class="slide"><img src="images/brands/Event.jpg"></div>
                    <div class="slide"><img src="images/brands/InsaTurbo.png"></div>
                    <div class="slide"><img src="images/brands/Hankook.png"></div>
                    <div class="slide"><img src="images/brands/Michelin.png"></div>
                    <div class="slide"><img src="images/brands/Goodyear.png"></div>
                    <div class="slide"><img src="images/brands/Continental.png"></div>
                </div>
            </div>
        </div>

        <!-- <div class="our-client">
            <div class="container">
                <video ref="videoRef" controlsList="nodownload" src="videos/Renkaatalle_presentation_1080p_FI_FINAL.mp4#t=0.8" id="video-container" width="100%" controls></video>
            </div>
        </div> -->

        <div class="contact-us">
            <div class="container">            
            <p class="mb-0">{{ $t('We give you service by phone also, Mon to Thu 8:00 – 18:00 and Fri 8:00 – 17:00') }} <a href="tel:040 552 9803"><i class="fa fa-phone fa-rotate-90"></i> 040 552 9803</a></p> 
            </div>
        </div>
        
        <div class="payment">
            <div class="container">            
                <div class="row">
                    <div class="col-md-3 d-flex align-items-center justify-content-md-end text-right">
                        <h3 class="text-uppercase font-weight-bold mb-4 mb-md-0">
                            <span class="font-weight-normal d-md-block">{{ $t('Payment') }}</span>
                            {{ $t('We Accept') }}
                        </h3>
                    </div>
                    <div class="col-md-9 p-0 payment-banners">
                        <div class="d-flex">
                          <img src="images/paymnet-logo.png">
                      </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mt-3 payment-banners">
                      <div class="klarna-banner">
                        <div v-html="KlarnaBannerHtml"></div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BFormSelect } from 'bootstrap-vue'
import { VueEditor } from "vue2-editor"
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import HomeViewAttachedService from "../components/HomeViewAttachedService";
import HomepageOpeningHourPopover from "../components/HomepageOpeningHourPopover";
import PopoverServicePointRight from "../components/PopoverServicePointRight";
import AppointmentPopup from "../components/AppointmentPopup";

export default {
    name: "home",
    metaInfo() {
        return {
            title: this.$t('Home Page'),
            meta: [
                { charset: 'utf-8' },
                { name: 'title', content:  'Home Page'},
                { name: 'description', content:  'Renkaatalle - A Finnish tyre shop at your service: Renkaatalle.fi. We deliver tyres cheaply and quickly, even within 24 hours, to almost all of Finland.'},
                { name: 'keywords', content:  'renkaatalle, A Finnish tyre shop, Renkaatalle.fi, finnish online store, Euro-Tyres Finland Ltd, deliver tyres cheaply and quickly, nexen, falken, pirelli, zeetex'},
                { name: 'robots', content: 'index,follow'},
                { property: 'og:title', content: "Renkaatalle - A Finnish tyre shop at your service: Renkaatalle.fi"},
                { property: 'og:site_name', content: 'Renkaatalle'},
                { property: 'og:type', content: 'website'},
            ]
        }
    },
    components: {
      'HomepageOpeningHourPopover' : HomepageOpeningHourPopover,
      'VueEditor' : VueEditor,
      'vue-google-autocomplete': VueGoogleAutocomplete,
      'HomeViewAttachedService' : HomeViewAttachedService,
      'appointment-popup': AppointmentPopup,
      'popover-service-point-right' : PopoverServicePointRight
    },
    component: {
        'b-form-select': BFormSelect
    },
    data() {
      return {
        licencePlateSearch: {
            vehicleType: 'Car',
            licencePlate: ''
        },
        searchBySize: {
            width: null,
            height: null,
            diameter: null,
            tyreSeason: null,
            loadIndex: null,
            speedIndex: null,
            brand: null,
            
        },
        isHome: true,
        isSearch: false,
        bannerList: [],
        bannerDetail: '',
        addressError: '',
        selectedSearchedTab : '',
        showModal : false,
        screenWidth: window.innerWidth,
      }
    },
    updated () {
        // $('.customer-logos').not('.slick-initialized').slick({slidesToShow: 3, infinite: false});
        $('.customer-logos').not('.slick-initialized').slick(this.getSlickOptions(true, 6, 1000, 3, 2, 2));
        $('.offers-banner').not('.slick-initialized').slick(this.getSlickOptions(true, 4, 1000, 3, 2, 2));
        $('.category-banner').not('.slick-initialized').slick(this.getSlickOptions(false, 1, 2000, 1, 1, 1));
    },
    computed: {
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('search', [
                'vehicleTypes', 
                'widths', 
                'heights', 
                'diameters', 
                'allSpeedIndexes', 
                'allLoadIndexes', 
                'allTyreSeasons', 
                'activeVehicleTypes',
                'activeWidth',
                'activeHeight',
                'activeDiameter',
                'activeSpeedIndex',
                'activeLoadIndex',
                'activeTyreSeason',
                'activeLicencePlate',
                'loading',
                'searchStatus',
                'brands',
                'activeBrand',
              'filteredTyreSeasons',]
            ),
        ...mapGetters("offers", ["offerList"]),
        ...mapGetters("cmspage", ["cmsPageContent", "homePageBannerText"]),
        ...mapGetters("search_dealer", ['service_points', 'selectedServicePoint', 'tyre_category']),
        ...mapGetters('appointments', ['holidays']),
        ...mapGetters('search_by_service_point', ['sbspLoader', 'showServices', 'defaultSort', 'address', 'defaultKilometer', 'default_v_t', 'kilometerRange', 'kilometerRange_fi', 'vehicle_types', 'vehicle_types_fi', 'sortingTitles', 'sortingTitles_fi', 'sortingOptions', 'sortingOptions_fi']),
        tyreSeasonsFiltered() {
          return this.filteredTyreSeasons;
        },
        KlarnaBannerHtml() {
            const formattedLocale = this.currentLang.replace("_", "-");
              if(this.screenWidth < 768 ) {
                return `<klarna-placement
                    data-key="homepage-promotion-box"
                    data-locale="${formattedLocale}"
                  ></klarna-placement>`;
              } else {
                return `<klarna-placement
                    data-key="homepage-promotion-wide"
                    data-locale="${formattedLocale}"
                  ></klarna-placement>`;
              }
        },
        defaultKilometer : {
          get() {
            return this.$store.getters["search_by_service_point/defaultKilometer"]
          },
          set(value) {
            this.$store.dispatch("search_by_service_point/setDefaultKilometer", value)
          }
      },
      default_v_t : {
        get() {
          return this.$store.getters["search_by_service_point/default_v_t"]
        },
        set(value) {
          this.$store.dispatch("search_by_service_point/setDefaultVT", value)
        }
      },
      defaultSort : {
        get() {
          return this.$store.getters["search_by_service_point/defaultSort"]
        },
        set(value) {
          this.$store.dispatch("search_by_service_point/setDefaultSort", value)
        }
      },
      address : {
        get() {
          return this.$store.getters["search_by_service_point/address"]
        },
        set(value) {
          this.$store.dispatch("search_by_service_point/setAddress", value)
        }
      },
      getSortingTitle() {
          return this.currentLang == "fi_FI" ? this.sortingTitles_fi[this.defaultSort] : this.sortingTitles[this.defaultSort]
      }

    },
    created() {
        if ("Default_V_T" in localStorage) {
          this.setDefaultVT(localStorage.getItem("Default_V_T"))
        }
        if ("DefaultKilometer" in localStorage) {
          this.setDefaultKilometer(localStorage.getItem("DefaultKilometer"))
        }
        this.fetchOffers()
        this.getCategoryBanners(this.currentLang, this.activeVehicleTypes)
        this.fetchVehicleTypes()
        this.getCmsPageContent({pageName: 'top-offer-header', lang: (this.currentLang == "fi_FI" ? 2 : 1)})
        this.getHomePageBannerText({pageName: 'home-page-banner-text', lang: (this.currentLang == "fi_FI" ? 2 : 1)})
        // this.fetchWidths();
        // this.getFilters();
        // this.licencePlateSearch.vehicleType= 'Car';

        // this.storeBrands();
        this.storeTyreSeasons();
        this.getHolidayList();
        if ("GoogleAddress" in localStorage) {
          this.searchServicePoints();
        }
    },
    mounted() {
      window.addEventListener("resize", this.handleResize);
        /**
         * Homepage Model commented Due to SEO changes by Taito
         * */
        /*if(typeof localStorage["homepage-modal-open"] === "undefined"){
            this.$bvModal.show('modal-2');
            // this.$refs['modal-2'].show()

            setTimeout(function(){ 
                const videoEl = document.getElementById('video-play');
                videoEl.muted = true;
                videoEl.play();
            }, 1000);

            localStorage.setItem('homepage-modal-open', '1')
        }*/
        this.setAddressManually()
    },
    watch: {
        '$route' () {
          this.setDefaultServicePoint()
        },
        service_points: {
          handler() {
            this.setDefaultServicePoint()
          }
        },
        activeVehicleTypes: {
            handler(newValue) {
                this.licencePlateSearch.vehicleType = (newValue === 'All' ? 'Car' : newValue);
                this.fetchWidths({});

                if (this.licencePlateSearch.vehicleType === 'Car') {
                    this.changeWidth(this.carSelectedWidth)
                    this.fetchHeights({ "width": this.searchBySize.width});
                    this.changeHeight(this.carSelectedAspectRatio)
                    this.fetchDiameters({ "searchBySize": this.searchBySize});
                    this.changeDiameter(this.carSelectedDiameter)
                    this.searchBySize.tyreSeason = this.carSelectedSeason
                    // this.changeBrand("Michelin")
                    // this.searchBySize.brand = "Michelin"
                } else if (this.licencePlateSearch.vehicleType === 'Light Truck')  {
                    this.changeWidth(this.vanSelectedWidth)
                    this.fetchHeights({ "width": this.searchBySize.width});
                    this.changeHeight(this.vanSelectedAspectRatio)
                    this.fetchDiameters({ "searchBySize": this.searchBySize});
                    this.changeDiameter(this.vanSelectedDiameter)
                    this.searchBySize.tyreSeason = this.vanSelectedSeason
                    
                    // this.changeBrand("Michelin")
                    // this.searchBySize.brand = "Michelin"
                } else if (this.licencePlateSearch.vehicleType === 'Truck')  {
                    this.changeWidth(this.truckSelectedWidth)
                    this.fetchHeights({ "width": this.searchBySize.width});
                    this.changeHeight(this.truckSelectedAspectRatio)
                    this.fetchDiameters({ "searchBySize": this.searchBySize});
                    this.changeDiameter(this.truckSelectedDiameter)
                    this.searchBySize.tyreSeason = this.truckSelectedSeason
                    // this.changeBrand("Michelin")
                    // this.searchBySize.brand = "Michelin"
                }
                this.changeVehicleType(newValue)
                if(this.activeBrand == null) {
                    this.searchBySize.brand = "All";
                } else {
                    if(this.brands.indexOf(this.activeBrand) == -1) {
                        this.searchBySize.brand = "All";
                    }
                }

                this.setSearchStatus(false)
                this.changeTyreSeasonStore(this.searchBySize.tyreSeason);

                if ($('.category-banner').hasClass('.slick-initialized')) {
                    $('.category-banner').slick('unslick')
                }
                this.getCategoryBanners(this.currentLang, newValue)
                this.storeBrands({ "searchBySize": this.searchBySize })
            },
            immediate: true
        },
        'activeWidth': {
            handler(newValue) {
                this.searchBySize.width = newValue;
            },
            immediate: true
        },
        'activeHeight': {
            handler(newValue) {
                this.searchBySize.height = newValue;
            },
            immediate: true
        },
        'activeDiameter': {
            handler(newValue) {
                this.searchBySize.diameter = newValue;
            },
            immediate: true
        },
        'activeSpeedIndex': {
            handler(newValue) {
                this.searchBySize.speedIndex = newValue;
            },
            immediate: true
        },
        'activeLoadIndex': {
            handler(newValue) {
                this.searchBySize.loadIndex = newValue;
            },
            immediate: true
        },        
        'activeTyreSeason': {
            handler(newValue) {
                this.searchBySize.tyreSeason = newValue;

                this.storeBrands({ "searchBySize": this.searchBySize })
            },
            immediate: true
        },
        'activeBrand': {
            handler(newValue) {
                if(newValue == null) {
                    this.searchBySize.brand = "All";
                } else {
                    this.searchBySize.brand = newValue;
                }
            },
            immediate: true
        },
        'activeLicencePlate': {
            handler(newValue) {
                this.licencePlateSearch.licencePlate = newValue;
            },
            immediate: true
        },
        'searchBySize.width': {
            handler() {
                this.fetchHeights({ "width": this.searchBySize.width});
            },
            immediate: true
        },
        'searchBySize.height': {
            handler() {
                this.fetchDiameters({ "searchBySize": this.searchBySize});
            },
            immediate: true
        },
        'searchBySize.diameter': {
            handler() {
                let season = process.env.VUE_APP_DEFAULT_SEASON
                if (this.licencePlateSearch.vehicleType === 'Car') {
                  season = this.carSelectedSeason
                }
                if (this.licencePlateSearch.vehicleType === 'Light Truck') {
                  season = this.vanSelectedSeason
                }
                if (this.licencePlateSearch.vehicleType === 'Truck') {
                  season = this.truckSelectedSeason
                }
                this.searchBySize.tyreSeason = season;
                this.storeBrands({ "searchBySize": this.searchBySize })
            },
            immediate: true
        },
        'currentLang': {
            handler(newValue) {
                this.setDealers([]);
                this.searchServicePoints();
                $('.offers-banner').slick('unslick')
                this.getCmsPageContent({pageName: 'top-offer-header', lang: (newValue == "fi_FI" ? 2 : 1)})
                this.getHomePageBannerText({pageName: 'home-page-banner-text', lang: (this.currentLang == "fi_FI" ? 2 : 1)})

                $('.category-banner').slick('unslick')
                this.bannerList = []
                this.getCategoryBanners(newValue, this.activeVehicleTypes)
                // if(newValue == 'en_GB') {
                //     this.$refs.videoRef.src = "videos/Renkaatalle_presentation_1080p_EN_FINAL.mp4#t=0.8";
                // } else if(newValue == 'fi_FI') {
                //     this.$refs.videoRef.src = "videos/Renkaatalle_presentation_1080p_FI_FINAL.mp4#t=0.8";
                // }
            }
        },
        // 'brands': {
        //     handler(newValue, oldValue) {
        //         // var allExist = this.brands.find(({ id }) => id === "All");
        //         // if (allExist == undefined) {
        //         //     this.brands.unshift({"id": "All", "name": "All"});

        //         //     // this.searchBySize.brand = "All";
        //         // }
        //     }
        // },
        'allTyreSeasons': {
            handler() {
                var allExist = this.allTyreSeasons.find(({ id }) => id === "All");
                if (allExist == undefined) {
                    this.allTyreSeasons.unshift({"id": "All", "name": "All"});
                }
            }
        },
        'defaultKilometer' : {
          handler(newKilometer) {
            localStorage.setItem("DefaultKilometer",newKilometer)
          }
        },
        'default_v_t' : {
          handler(newVehicleType) {
            localStorage.setItem("Default_V_T",newVehicleType)
          }
        }
    },
    methods: {
        ...mapActions("search", [
            "filterProducts", 
            "getFilters", 
            "fetchWidths", 
            "fetchHeights", 
            "fetchDiameters", 
            "changeCarTypes",
            "changeWidthStore",
            "changeHeightStore",
            "changeDiameterStore",
            "changeSpeedIndexStore",
            "changeLoadIndexStore",
            "changeTyreSeasonStore",
            "changeLicencePlateStore",
            "fetchVehicleTypes", 
            "fetchAllSpeedIndexes",
            "fetchAllTyreSeasons",
            "fetchAllLoadIndexes",
            "storeBrands", 
            "storeTyreSeasons",
            "setSearchStatus",
            "changeBrandStore"]),
        ...mapActions("offers", ["fetchOffers"]),
        ...mapActions("banners", ["fetchBanners"]),
        ...mapActions("cmspage", ["getCmsPageContent", "getHomePageBannerText"]),
        ...mapActions("search_dealer", ["fetchDealers", 'setStrAddressWS', 'setSearchedZipcode', 'setDealers', 'setSelectedServicePoint', 'getTyreCategoryByVehicleType']),
        ...mapActions('appointments', ['getHolidayList']),
        ...mapActions('search_by_service_point', ['setShowServices', 'searchServicePoints', 'sortSearchedServicePoints', 'setDefaultKilometer', 'setDefaultVT', 'setDefaultServicePoint', 'removeOlderAppointment']),
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
        customLabel({ company_name, city }) {
          return `${company_name} - ${city}`
        },
        handleSubmit() {
        },
        changeWidth(seletedWidth){
            this.changeWidthStore(seletedWidth);
        },
        changeHeight(seletedHeight){
            
            this.changeHeightStore(seletedHeight);
        },
        changeDiameter(seletedDiameter){
            this.changeDiameterStore(seletedDiameter);
        },
        changeInch(seletedInch){
            this.changeInchterStore(seletedInch);
        },
        changeSpeedIndexes(seletedSpeedIndexes){
            this.changeSpeedIndexStore(seletedSpeedIndexes);
        },
        changeLoadIndexes(seletedLoadIndexes){
            this.changeLoadIndexStore(seletedLoadIndexes);
        },
        changeTyreSeason(seletedTyreSeason){
            this.changeTyreSeasonStore(seletedTyreSeason);
        },
        changeVehicleType(cartypeData) {
            // this.carType = cartypeData;
            this.changeCarTypes(cartypeData);

            // this.searchBySize.width = null;
            // this.searchBySize.height = null;
            // this.searchBySize.diameter = null;
            //this.searchBySize.tyreSeason = process.env.VUE_APP_DEFAULT_SEASON
            this.searchBySize.speedIndex = null;
            this.searchBySize.brand = "All";
            this.selectedSearchedTab = cartypeData;
        },
        onSubmitLicencePlateSearch(form){
            
        },
        async searchByTyreSize(ServicePoint) {
            var ServicePoint = ServicePoint || null;
            let selectBrands = [];
            if (this.searchBySize.brand == "All") {
                if(this.brands.length != 0 ) {
                    let filtered = this.brands.filter((el) => {
                        if(el.name != "All") {
                            selectBrands.push(el.name);
                        }
                    });
                }
            } else if(this.searchBySize.brand != null) {
                selectBrands = this.searchBySize.brand
            }

            let selectTyreSeasons = [];
            if (this.searchBySize.tyreSeason == "All") {
                if(this.allTyreSeasons.length != 0 ){
                    let filtered = this.allTyreSeasons.filter((el) => {
                        if(el.name != "All") {
                            selectTyreSeasons.push(el.name);
                        }
                    });
                }
            } else if(this.searchBySize.tyreSeason != null) {
                selectTyreSeasons.push(this.searchBySize.tyreSeason)
            }

            if (ServicePoint != null) {
              var QS = {}
              var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
              if (selectedServicePoint) {
                QS['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
              }

              await this.fetchVehicleTypes(QS);

              this.licencePlateSearch.vehicleType = this.vehicleTypes[0].car_type;
              query = { ServicePoint: this.normalizeString(this.selectedServicePoint != null ? this.selectedServicePoint.company_name : '') };
            } else {
              var query = {
                width: this.searchBySize.width,
                height: this.searchBySize.height,
                diameter: this.searchBySize.diameter,
                // tyre_season: this.searchBySize.tyreSeason,
                tyre_season: selectTyreSeasons,
                speed_index: this.searchBySize.speedIndex,
                load_index: this.searchBySize.loadIndex,
                // brand: this.searchBySize.brand,
                brand: selectBrands,
              }
              await this.removeSelectedServicePoint();
              if (this.licencePlateSearch.vehicleType === 'Car') {
                localStorage.setItem('car_selected_width', this.searchBySize.width)
                localStorage.setItem('car_selected_aspect_ratio', this.searchBySize.height)
                localStorage.setItem('car_selected_diameter', this.searchBySize.diameter)
                localStorage.setItem('car_selected_season', this.searchBySize.tyreSeason)
              }
              if (this.licencePlateSearch.vehicleType === 'Light Truck') {
                localStorage.setItem('van_selected_width', this.searchBySize.width)
                localStorage.setItem('van_selected_aspect_ratio', this.searchBySize.height)
                localStorage.setItem('van_selected_diameter', this.searchBySize.diameter)
                localStorage.setItem('van_selected_season', this.searchBySize.tyreSeason)
              }
              if (this.licencePlateSearch.vehicleType === 'Truck') {
                localStorage.setItem('truck_selected_width', this.searchBySize.width)
                localStorage.setItem('truck_selected_aspect_ratio', this.searchBySize.height)
                localStorage.setItem('truck_selected_diameter', this.searchBySize.diameter)
                localStorage.setItem('truck_selected_season', this.searchBySize.tyreSeason)
              }
            }

            await this.getTyreCategoryByVehicleType(this.licencePlateSearch.vehicleType)
            var route_name = this.currentLang === 'en_GB' ? 'product_list_by_vehicle_type' : 'product_list_by_vehicle_type_fi'
            var route_param_vt = this.currentLang === 'en_GB' ? this.tyre_category.slug_en : this.tyre_category.slug_fi
            var route = {name: route_name,query: query,replace: true}
            if(route_param_vt) {
              route.params = { vehicletype: route_param_vt }
            }
            this.$router.push(route);
        },
        getCategoryBanners(currentLang, activeVehicleTypes) {
            this.bannerLoading = true
            this.fetchBanners({ locale_id: currentLang == "fi_FI" ? 2 : 1, tyre_category_id: (activeVehicleTypes == 'Car') ? 2 : 3 })
                .then(response => {
                    this.bannerList = response.data
                    this.bannerLoading = false
                }).catch((error) => {
                    console.log(error)
                })
        },
        getSlickOptions(infinite, slidesToShow, autoplaySpeed, rs1, rs2, rs3) {
            return {
                infinite: infinite,
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: autoplaySpeed,
                arrows: false,
                dots: false,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: rs1
                        }
                    }, {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: rs2
                        }
                    }, {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: rs3
                        }
                    }
                ]
            };
        },
        changeBrand(seletedBrand){
            this.changeBrandStore(seletedBrand);
        },
        getAddressData(place, placeResultData) {
          localStorage.setItem('GoogleAddress', JSON.stringify(place))
          localStorage.setItem('GoogleSelectedPlace', JSON.stringify(placeResultData))
          this.address = placeResultData.formatted_address;
        },
        setAddressManually() {
          if ("GoogleSelectedPlace" in localStorage) {
            const placeResultData = JSON.parse(localStorage.getItem("GoogleSelectedPlace"))
            this.address = placeResultData.formatted_address;
            this.searchServicePoints();
          }
        },
        /*searchServicePoints(lang = "") {
          if (!("GoogleAddress" in localStorage)) {
            this.$refs.autocomplete.focus();
            return;
          }
          this.sbspLoader = true
          let params= '';
          const Address = localStorage.getItem('GoogleAddress');
          let addressCoordinates = (Address) ? JSON.parse(Address) : null
          if(addressCoordinates && addressCoordinates.latitude) {
            params = 'latitude=' + addressCoordinates.latitude
          }
          if(addressCoordinates && addressCoordinates.longitude) {
            params = params + '&longitude=' + parseFloat(addressCoordinates.longitude).toFixed(8)
          }

          let locale_code = (this.currentLang == '') ? 'fi_FI' : this.currentLang
          let locale_id = (locale_code == 'en_GB') ? 1 : 2
          params = params + '&locale_id='+ locale_id
          params = params + '&with=["timeSlots","workingDays"]'
          params = params + '&search_radius='+this.defaultKilometer
          params = params + '&vehicle_type='+this.default_v_t

          this.fetchDealers(params).finally(() => {
            this.sbspLoader = false
            this.sortSearchedServicePoints()
          })

          this.setSearchedZipcode(this.address);
          this.showServices = true;
        },*/
        async selectAndRemoveServicePoint(ServicePoint) {
            this.setSelectedServicePoint(ServicePoint)
            localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(ServicePoint))
        },
        async removeSelectedServicePoint() {
            localStorage.removeItem("SearchedSelectedServicePoint")
            await this.fetchVehicleTypes();
        },
        clearSearchedServicePoint() {
          if(this.$refs.autocomplete.$el.value === '') {
            localStorage.removeItem("SearchedSelectedServicePoint")
            localStorage.removeItem('GoogleAddress')
            localStorage.removeItem('GoogleSelectedPlace')
            localStorage.removeItem('DefaultKilometer')
            localStorage.removeItem('Default_V_T')
            this.defaultKilometer = 20
            this.default_v_t = 1
            this.setSelectedServicePoint(null)
            this.setShowServices(false)
            this.address = ''
            this.setDealers([]);
          }
        },
        removeAppointmentPopup() {
          this.showModal = false
        }
    }
};
</script>
<style scoped>
.offers-banner .slick-slide {
    box-shadow: none;
    height: auto;
    padding: 0px !important;
}
.offers-banner img {
    /* width: 400px;
    height: 374px; */
    box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
    -moz-box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
    -webkit-box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
    -khtml-box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
}

/* .cp-main #home { position: relative; top: 74px; } */
.category-banner .slick-slide { height: 600px; width:100%; overflow:hidden; }
.category-slider-show { position: relative; }
.category-slider-show .banner-area { position: absolute; top: 0; width: 100%; height: 100%; }
.category-slider-show .slick-slide { padding: 0px; margin: 0px; }
.category-slider-show .slick-slide img { width: 100%; height: auto; position: absolute; left: 0; right: 0; top: -100%;}

.cs-search-home .srch-form #tyreSeason {
    max-width: 120px !important;
    padding-right: 25px !important;
}

.cs-search-home .srch-form #brand { 
    min-width: 85px !important;
    padding-right: 25px;
}
.sizeRefImg {
    padding-left: 11% !important;
}
.home-page-fi_FI #brand{
    min-width: 75px !important;
}

.home-page-fi_FI .sizeRefImg { 
    padding-left: 26% !important;
}

.home-page-en_GB .sizeRefImg { 
    padding-left: 11% !important;
}

.home-page-fi_FI .srch-form .custom-select{
    min-width: 75px !important;
}

.home-page-en_GB .srch-form .custom-select{
    min-width: 75px !important;
}

.payment-banners img {
    width: 80%;}

@media only screen and (min-width: 768px) and (max-width: 991px) {   
    .category-slider-show .slick-slide img {
        height: 700px;
    }
}

@media only screen and (max-width: 768px) {   
    .category-slider-show .slick-slide img {
        height: 800px;
    }
}

@media only screen and (max-width: 576px) {
    .banner-area { padding: 40px 0px 0px 0px; }
    .category-slider-show { position: relative; }
    .category-slider-show .banner-area { position: relative; }
    .category-slider-show .slick-slide img { margin-top: 74px; height: 240px; }
}

/* @media only screen and (max-width: 576px) { 
    .category-slider-show { position: initial; }
    .category-slider-show .banner-area { position: initial; }
    .category-slider-show .slick-slide { padding: 0px; margin: 0px; }
    .category-slider-show .slick-slide img { margin-top: 70px; height: auto; }
} */

.flex-grow-1 {
  flex: 1;
}
.align-items-normal {
  align-items: normal !important;
}

.search-by-service-point-btn {
  border: 1px solid #1b9b38 !important;
  background: #28a745;
  color: #fff;
  border-radius: 0 20px 20px 0;
}
.search-by-service-point-btn i {
    padding-left: 20px;
}
.sp-input-group .sp-search-btn-append {display: none !important;}

@media (min-width: 281px) {
  .cs-search-home .srch-title.sp-title.sp-title-finish {
    min-width: 170px !important;
  }
}
@media (max-width: 280px) {
  .cs-search-home .srch-title.sp-title {
    min-width: 170px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px){
  .sp-search-form .sp-form-item {
    display: block !important;
    font-size: 13px;
    margin-bottom: 1rem;
    width: auto !important;
  }

  .sp-search-form .search-button-title{display: none;}
  .sp-search-form .search-button {
    display: ruby;
    border-radius: 0 !important;
  }
  .form-group.sp-form-item.d-max-767 {
    display: none !important;
  }
  .cs-search-home .srch-title.sp-title {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #da9d26 !important;
    margin-bottom: 1rem;
    text-transform: uppercase;
    text-align: center;
    padding: 12px;
  }
}

@media (min-width: 426px) and (max-width: 767px){
  .sp-search-form .search-button-title{display: none;}
  .sp-search-form .search-button,
  .sp-input-group .sp-search-btn-append{
    display: ruby !important;
    width: 20% !important;
    border-radius: 0 !important;
  }
  .google-input-box.sp-search-input-append {
    width: 80% !important;
  }
  .sp-search-form .sp-search-btn-append .search-icon {margin-left: 0 !important;}

  .sp-search-form .sp-form-item.sp-input-group {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    width: 100%;
  }
}

@media (max-width: 767px){
  .cs-search-home.search-by-service-point-container .form-inline {
    flex-direction: column;
    align-items: stretch;
  }

  .cs-search-home .srch-title.sp-title {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #da9d26 !important;
    margin-bottom: 1rem;
    text-transform: uppercase;
    text-align: center;
    padding: 12px;
  }
  .search-by-service-point-btn {
    margin-top: 1rem;
    width: 100%;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .sp-search-form .sp-form-item {
    margin-bottom: 1rem;
    width: 100%;
  }
}

@media (max-width: 1200px) {
  .cs-search-home.search-by-service-point-container .srch-title {
    padding: 7px 20px 5px !important;
  }
}
.klarna-banner {
    max-width: 728px;
    margin: 0 auto;
}
.klarna-banner klarna-placement {
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
}
</style>
<style>
.klarna-banner klarna-placement {
  max-width: 728px !important;
}
@media screen and (min-width: 768px) and (max-width: 991px){
.klarna-banner klarna-placement {
    width: 100%;
  }
}
@media (min-width: 426px) and (max-width: 767px) {
  .klarna-banner klarna-placement {
    width: 85% !important;
  }
  .klarna-banner {
    max-width: 50% !important;
  }
}
@media (max-width: 426px) {
  .klarna-banner klarna-placement {
    width: 80%;
  }
  .payment {
    text-align: center;
  }
}
</style>
